import React, { useEffect, useState } from "react";
import "../styles/ReviewModal.css";
import ReviewStars from "./ReviewStars"; // ⭐ 별점 선택 컴포넌트

const ReviewModal = ({ onClose, orderItem }) => {
    const [rating, setRating] = useState(0); // ⭐ 선택된 별점
    const [reviewText, setReviewText] = useState(""); // ✅ 리뷰 입력 텍스트
    const [productInfo, setProductInfo] = useState({ itemName: "", postDate: "", orderCount: 0, subscriptionPeriod: 0 }); // ✅ 상품 정보
    const maxLength = 1000; // ✅ 리뷰 최대 길이

    // ✅ 리뷰 데이터 불러오기
    useEffect(() => {
        const fetchReviewData = async () => {
            if (!orderItem.itemId) return;

            try {
                const response = await fetch(`/api/review/write?itemId=${orderItem.itemId}${orderItem.orderItemId ? `&orderItemId=${orderItem.orderItemId}` : ""}`);
                if (response.ok) {
                    const data = await response.json();
                    setProductInfo({
                        itemName: data.itemName || "상품명 없음",
                        itemThumbnailPath : data.itemThumbnailPath || "",
                        postDate: data.postDate || "",
                        orderCount: data.orderCount || 0,
                        subscriptionPeriod: data.subscriptionPeriod || 0
                    });
                    setRating(data.rate || 0);
                } else if (response.status === 409) {
                    alert("이미 리뷰를 작성한 상품입니다.");
                    // 새로고침
                    window.location.reload();
                    onClose();
                }
            } catch (error) {
                console.error("리뷰 데이터를 불러오는 중 오류 발생:", error);
            }
        };

        fetchReviewData();
    }, [orderItem.itemId, orderItem.orderItemId, onClose]);

    // ⭐ 별점 선택 핸들러
    const handleRatingChange = (value) => {
        console.log("선택한 별점:", value);
        setRating(value);
    };

    // ✅ 리뷰 등록 API 호출
    const handleSubmit = async () => {
        if (reviewText.length < 10) {
            alert("리뷰는 최소 10자 이상 입력해야 합니다.");
            return;
        }

        // 🔥 리뷰 데이터 객체 생성 (ReviewForm DTO와 일치하도록)
        const reviewData = {
            itemId : orderItem.itemId,
            orderCount: orderItem.count, // 주문 수량 (예제 값)
            subscriptionPeriod: orderItem.subscriptionPeriod, // 구독 기간 (없다면 기본값 0)
            content: reviewText,
            rate: rating, // 별점
        };

        try {
            const response = await fetch(`/api/review/write?itemId=${orderItem.itemId}&orderItemId=${orderItem.orderItemId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(reviewData),
            });

            const result = await response.json();

            if (response.ok) {
                alert("✅ 리뷰가 성공적으로 등록되었습니다!");
                onClose();
                // 새로고침
                window.location.reload();
            } else {
                alert(`❌ 리뷰 등록 실패: ${result.result || "다시 시도해주세요."}`);
            }
        } catch (error) {
            console.error("리뷰 등록 중 오류 발생:", error);
            alert("❌ 서버 오류: 다시 시도해주세요.");
        }
    };


    return (
        <div className="review-form-overlay">
            <div className="review-form">
                {/* 닫기 버튼 */}
                <button className="review-form-close" onClick={onClose}>✖</button>

                {/* 헤더 */}
                <div className="review-form-header">
                    <h2>리뷰 작성하기</h2>
                </div>

                <div className="review-form-content">
                    {/* 상품 정보 */}
                    <div className="review-form-info">
                        <div className="review-form-image">
                            <img src={productInfo.itemThumbnailPath} alt="상품 이미지" />
                        </div>
                        <div className="review-form-details">
                            <p className="review-form-date">{productInfo.postDate}</p>
                            <p className="review-form-name">{productInfo.itemName}</p>
                            <p className="review-form-quantity">{productInfo.orderCount}개 {productInfo.subscriptionPeriod}개월</p>
                        </div>
                    </div>

                    {/* ⭐ 별점 선택 */}
                    <ReviewStars rating={rating} onRatingChange={handleRatingChange} />

                    {/* 리뷰 입력창 */}
                    <textarea
                        className="review-form-textarea"
                        placeholder="상품 평을 남겨주세요 (최소 10자 이상)"
                        maxLength={maxLength}
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                    ></textarea>

                    {/* 글자 수 제한 */}
                    <div className="review-form-text-limit">
                        <p>{reviewText.length} / {maxLength}</p>
                    </div>

                    {/* 유의사항 */}
                    <div className="review-form-notice">
                        리뷰 작성 시 유의사항
                        <hr className="review-form-notice-hr" />
                        <p>작성하신 리뷰는 '마이페이지 > 리뷰내역'에서 확인하실 수 있습니다.</p>
                        <p>부적절한 게시물 등록 시 무통보 삭제될 수 있습니다.</p>
                        <p>- 비방/욕설/명예훼손 등 논쟁을 일으킬 수 있는 내용이 기재된 경우</p>
                        <p>- 리뷰 게시판의 목적과 운영 방식에 맞지 않는 내용이 기재된 경우</p>
                    </div>

                    {/* 버튼 */}
                    <div className="review-form-buttons">
                        <button className="review-form-submit" onClick={handleSubmit}>등록하기</button>
                        <button className="review-form-cancel" onClick={onClose}>취소</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewModal;
